export enum SendStepsEnum {
  General,
  Beneficiary,
  Bank,
  Summary,
  Mfa,
  Success,
}
